"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JSDateToAPIDate = JSDateToAPIDate;
exports.endOfDay = endOfDay;
exports.formatDate = formatDate;
exports.formatUTCDate = formatUTCDate;
exports.getDaysAgo = getDaysAgo;
exports.parseDate = parseDate;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDate(date, format) {
  return (0, _dayjs.default)(date).format(format);
}

function formatUTCDate(date, format) {
  return (0, _dayjs.default)(date).utc().format(format);
}

function parseDate(string, format) {
  return (0, _dayjs.default)(string, format);
}
/*
* Specific function for Advanced Search adds a day minus 1 sec
*/


function endOfDay(date) {
  return (0, _dayjs.default)(date).endOf('day');
}
/**
 * @return {string}
 */


function JSDateToAPIDate(date) {
  var ISODate = (0, _dayjs.default)(date).format();
  return ISODate.substring(0, ISODate.length - 6);
}
/**
 * Get days ago from date
 * @param date
 * @returns {number}
 */


function getDaysAgo(date) {
  var inputDate = (0, _dayjs.default)(date);
  var currentDate = (0, _dayjs.default)().startOf('day');
  return currentDate.diff(inputDate, 'day');
}